// import Cookies from "js-cookie";
// import { storeS } from "@/store";

// const companyId = "792fe762-b138-4c3e-9b5f-a4a310fc4a0f";

// export function initToken() {
//   console.log("inittoken >>");

//   if (process.env.NODE_ENV != "production") {
//     console.log(process.env.NODE_ENV);
//     storeS.savedTokenAndCompany = "B6GHZZNazQhsHD5fk5ZSyD3NAb2BH4YG"; //Max
//     // storeS.savedTokenAndCompany = "5DibZrSATdhfs22YYY9dzf8d7n84zZnh"; // Borys

//     storeS.savedTokenAndCompany +=
//       "&companyId=792fe762-b138-4c3e-9b5f-a4a310fc4a0f"; // Константа
//   } else if (process.env.NODE_ENV == "production") {
//     // Функція, для вилучення куків
//     // eslint-disable-next-line no-inner-declarations
//     function getCookie(name) {
//       const value = `; ${document.cookie}`;
//       const parts = value.split(`; ${name}=`);
//       if (parts.length === 2) return parts.pop().split(";").shift();
//       return null;
//     }

//     // Формуємо наш url та забираємо з нього параметр token
//     const url = new URL(window.location.href);
//     const tokenParam = url.searchParams.get("token");
//     console.log("tokenParam >", tokenParam);

//     if (![null, undefined, ""].includes(tokenParam)) {
//       // Якщо знаходимо параметр token
//       Cookies.set(`token`, tokenParam);
//       storeS.savedTokenAndCompany =
//         storeS.savedTokenAndCompany = `${tokenParam}&companyId=792fe762-b138-4c3e-9b5f-a4a310fc4a0f`;
//       storeS.token = tokenParam;
//     } else if (document.cookie.indexOf("token=") != -1) {
//       storeS.savedTokenAndCompany = storeS.savedTokenAndCompany = `${getCookie(
//         "token"
//       )}&companyId=792fe762-b138-4c3e-9b5f-a4a310fc4a0f`;
//       storeS.token = getCookie("token");
//     } else {
//       alert(i18n.global.t("dontAccess"));
//       window.location.href("https://cabinet.skyservice.online/");
//     }
//   }
// }

// export function getTokenString() {
//     var tokenString = "";
//   console.log("savedTokenAndCompany > ", storeS.savedTokenAndCompany);
//   if (storeS.savedTokenAndCompany == null) {
//     initToken();
//   } else {
//     tokenString = storeS.savedTokenAndCompany
//   }

// //   return storeS.savedTokenAndCompany || initToken();
// return tokenString;
// }

import Cookies from "js-cookie";
import { storeS } from "@/store";

export function initToken() {
  const isProd = process.env.NODE_ENV === 'production';

  if (!isProd) {
    const devToken = 'B6GHZZNazQhsHD5fk5ZSyD3NAb2BH4YG';
    const DEV_COMPANY_ID = '792fe762-b138-4c3e-9b5f-a4a310fc4a0f';
    storeS.token = devToken;
    storeS.companyId = DEV_COMPANY_ID;
    storeS.savedTokenAndCompany = `${devToken}&companyId=${DEV_COMPANY_ID}`;
    return;
  }

  const url = new URL(window.location.href);
  const tokenParam = normalize(url.searchParams.get('tokenInside'));
  const companyParam = normalize(url.searchParams.get('companyId'));

  const cookieToken = normalize(Cookies.get('tokenInside'));
  const cookieCompany = normalize(Cookies.get('companyId'));

  const token = tokenParam || cookieToken;
  const companyId = companyParam || cookieCompany;

  if (token && companyId) {
    Cookies.set('tokenInside', token, { secure: true, sameSite: 'None', path: '/' }); // None: readable in SkyHub silent iframe (3rd-party)
    Cookies.set('companyId', companyId, { secure: true, sameSite: 'None', path: '/' });

    storeS.token = token;
    storeS.companyId = companyId;
    storeS.savedTokenAndCompany = `${token}&companyId=${companyId}`;

    if (tokenParam || companyParam) {
      const clean = window.location.pathname + window.location.hash;
      history.replaceState({}, '', clean);
    }
    return;
  }

  if (!token) {
    Cookies.remove('tokenInside', { path: '/' });
    alert(i18n.global.t("dontAccess"));
    window.location.href = "https://cabinet.skyservice.online/";
  }
  if (!companyId) Cookies.remove('companyId', { path: '/' });
}

export function getTokenString1() {
  console.log("savedTokenAndCompany > ", storeS.savedTokenAndCompany);
  console.log("Dev mode:", process.env.NODE_ENV);

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  console.log("tokeeen > ", getCookie("tokenInside"));
  console.log("companyId > ", getCookie("companyId"));

  if (!storeS.savedTokenAndCompany) {
    initToken();
  }
  console.log("getTokenString > ", storeS.savedTokenAndCompany);

  return storeS.savedTokenAndCompany || "";
}

export function getTokenString() {
  if (!storeS.savedTokenAndCompany) initToken();

  // подстраховка
  if (!storeS.savedTokenAndCompany) {
    const t = normalize(Cookies.get('tokenInside'));
    const c = normalize(Cookies.get('companyId'));
    if (t && c) storeS.savedTokenAndCompany = `${t}&companyId=${c}`;
  }

  return storeS.savedTokenAndCompany || '';
}
